import ACalendarField from './index.vue';

ACalendarField.install = app => {
  app.component(ACalendarField.name, ACalendarField);
};

export default ACalendarField;
